import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ChatService } from '../chat.service';
import { InputDirective } from "../../input/input.directive";
import { PreloaderService } from "../../service/preloader.service";
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDatepicker } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from 'src/app/auth/_services/authentication.service';


@Component({
  selector: 'app-alj-denied',
  templateUrl: './alj-denied.component.html',
  styleUrls: ['./alj-denied.component.scss'],
  providers: [DatePipe]
})
export class AljDeniedComponent implements OnInit {
  @ViewChild(InputDirective, { static: false }) input: InputDirective;
  @Output() popUpClosed = new EventEmitter();
  @Output() gotoMainAlj = new EventEmitter();

  representedHearingOptions = [
    { text: 'I was not represented', value: 'I was not represented' },
    { text: 'I was represented by an Attorney', value: 'I was represented by an Attorney' },
    { text: 'I was represented by a Non-Attorney', value: 'I was represented by a Non-Attorney' }
  ];

  firstStep = false;
  secondStep = false;
  alj_denied = {
      firstName: '',
      lastName: '',
      phoneNumber: null,
      email: '',
      unfavorableDate: null,
      representedHearing: null,
      contactingInfo: null,
      summary: '',
      type: 1
    };

  selectedOption = 'yes';

  represented = null;
  popupShow = false;
  popupSuccess = false;
  popupMessage = '';

  constructor(private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private preloaderService: PreloaderService, private datePipe: DatePipe) {
  }

  ngOnInit() {
  }

  handleGuestSave() {
    this.preloaderService.show();
    this.popupShow = false;

    this.chatService.setGuestInfo(this.alj_denied).subscribe((res: any) => {
      const aljDenied = {firstName: this.alj_denied.firstName, lastName: this.alj_denied.lastName, phone: this.alj_denied.phoneNumber, email: this.alj_denied.email, type: 'ALJ Denied'};
      this.authenticationService.alertPaperclip(aljDenied);
      this.preloaderService.hide();
      if (res.status) {
        this.popupShow = true;
        this.popupSuccess = true;
      } else {
        this.popupShow = true;
        this.popupSuccess = false;
      }

      this.popupMessage = res.message;
    });
  }

  closePopup(){
    this.firstStep = false;
    this.secondStep = false;
    this.alj_denied = {
      firstName: '',
      lastName: '',
      phoneNumber: null,
      email: '',
      unfavorableDate: null,
      representedHearing: null,
      contactingInfo: null,
      summary: '',
      type: 1
    };

    this.popUpClosed.emit();
  }

  goNext(step){
    switch(step){
       case 1:{
          this.firstStep = false;
          this.secondStep = false;
          this.alj_denied = {
            firstName: '',
            lastName: '',
            phoneNumber: null,
            email: '',
            unfavorableDate: null,
            representedHearing: null,
            contactingInfo: null,
            summary: '',
            type: 1
          };
          break;
      }
      case 2:{
        this.firstStep = false;
        this.secondStep = false;
        this.gotoMainAlj.emit(true);
        break;
      }
      case 3:{
        this.firstStep = true;
        this.gotoMainAlj.emit(false);
        break;
      }
      case 4:{
        this.firstStep = false;
        this.secondStep = true;
        break;
      }
    }
  }

  getMaxDate(): Date {
      return new Date(); // Return the maximum allowed date here
  }

  valueChange(value){
    this.alj_denied.unfavorableDate = this.formatDate(value);
  }
  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'MM/dd/yyyy');
  }

}
